import React from 'react';
import Link from 'next/link';
import { useAccCenterApplyCount } from '@repository/acc';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './floatingBar.module.scss';
const cx = classnames.bind(styles);

const FloatingBar = () => {
  const { data } = useAccCenterApplyCount();

  return (
    // 하단 플로팅 바
    <div className={cx('floatingBar')}>
      <div className={cx('floatingInner')}>
        <span className={cx('floatingText')}>
          벌써 <span className={cx('count')}>{data?.total}</span>명이 JOBDA 역검에 응시했어요!
        </span>
        <Link href={RouteUrl.ACCA_TEST_GATE} legacyBehavior>
          <a className={cx('floatingBtn', 'acca_intro_testGo')} role="button">
            역량검사 바로가기
          </a>
        </Link>
      </div>
    </div>
  );
};

export default FloatingBar;
